export const isMask = (constructor?: any) => constructor && constructor.name === 'Mask'

export default isMask
